import { useContext, useEffect, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IosShareIcon from "@mui/icons-material/IosShare";
import { ClickAwayListener, Tooltip } from "@mui/material";
import { LocalizationContext } from "../lib/context";

export default function ShareButton({
  linkObj,
  buttonSize = "medium",
  smAndDown,
  withoutText,
}: {
  linkObj: any;
  buttonSize?: "small" | "medium" | "large";
  smAndDown?: boolean;
  withoutText?: boolean;
}) {
  const { localeStrings } = useContext(LocalizationContext);
  const [openToolTip, setOpenToolTip] = useState(false);
  const [canShare, setCanShare] = useState(true);

  useEffect(() => {
    setCanShare(!!navigator && !!navigator.share);
  }, []);

  async function handleClick() {
    if (canShare) {
      try {
        await navigator.share(linkObj);
      } catch (e: any) {
        // console.error(e.toString());
      }
    } else {
      navigator.clipboard?.writeText(linkObj.url).then(() => {
        setOpenToolTip(true);
      });
    }
  }

  return (
    <ClickAwayListener
      onClickAway={() => {
        setOpenToolTip(false);
      }}
    >
      <Tooltip
        PopperProps={{
          disablePortal: true,
        }}
        open={openToolTip}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        placement="top-end"
        title={localeStrings.uiGeneral.copied}
      >
        <div
          onClick={() => handleClick()}
          className="flex gap-normal align-items-end share-link pointer"
        >
          {!canShare ? (
            <ContentCopyIcon sx={{ width: 20 }} />
          ) : (
            <IosShareIcon sx={{ width: 20 }} />
          )}
          {!smAndDown && !withoutText && (
            <div className="subtitle-4 underline-link">
              {!canShare
                ? localeStrings.uiGeneral.copyButton
                : localeStrings.uiGeneral.shareButton}
            </div>
          )}
        </div>
      </Tooltip>
    </ClickAwayListener>
  );
}
